import React from 'react';
import { Button, Menu } from '@fragments';
import { IconFlask, IconLogout2, IconRefresh } from '@tabler/icons-react';
import { studioMock } from '../../data/studioApi';
import { STUDIO_AUTOMATIONS } from '../../enums/routes';
import './styles.scss';

const CONFIRMED_KEY = 'ginastee:studio:onboarding:confirmed';

// Only with `?mock=true`: which scenario the in-memory backend plays, and a way to
// switch, restart or leave it. Each option reloads, since the client is created at load.
export default function StudioMockBadge({ studio: s }) {
  if (!studioMock) return null;
  const { t } = s;
  // A Direct Messages scenario opens on its screens.
  const go = query => window.location.assign(`${/scenario=automations/.test(query) ? STUDIO_AUTOMATIONS : '/studio'}?${query}`);
  const restart = scenario => {
    studioMock.reset();
    try { window.sessionStorage.removeItem(CONFIRMED_KEY); } catch { /* Nothing stored. */ }
    go(`mock=true&scenario=${scenario}`);
  };
  const items = [
    ...studioMock.scenarios.map(name => ({ id: name, label: t(`mockScenario_${name}`), active: name === studioMock.scenario, onClick: () => go(`mock=true&scenario=${name}`) })),
    { divider: true },
    { id: 'reset', label: t('mockReset'), icon: <IconRefresh />, onClick: () => restart(studioMock.scenario) },
    { id: 'exit', label: t('mockExit'), icon: <IconLogout2 />, onClick: () => go('mock=false') },
  ];
  return <div className="studio-mock-badge">
    <Menu items={items} placement="top-end">
      <Button variant="rounded" color="overlay" size="small" startIcon={<IconFlask />} aria-label={t('mockLabel')}>
        {t(`mockScenario_${studioMock.scenario}`)}
      </Button>
    </Menu>
  </div>;
}
